import type {State} from 'src/reducers';
import type {CredentialsConfig} from 'src/types/data-integration';


export const selectCredentials = (state: State): CredentialsConfig | null =>
  state.dataIntegration.credentials;
export const selectCredentialsMetaData = (
  state: State,
): CredentialsConfig | null => state.dataIntegration.credentialsMetaData;
